module.exports = __webpack_public_path__ + "img/28663998000123.b21cf9fa.png";